export enum RoomFilter {
  ALL = "ALL",
  OPEN_CONNECTED = "OPEN_CONNECTED",
  NOT_ENCLOSED = "NOT_ENCLOSED",
}

export enum OpeningPlacementFilter {
  DIFFERENT_BLOCKS = "DIFFERENT_BLOCKS",
}

export enum WindowLateralAlignment {
  OUTSIDE_FACE = "OUTSIDE_FACE",
  INSIDE_FACE = "INSIDE_FACE",
  CENTERLINE = "CENTERLINE",
}

export enum WindowVerticalAlignment {
  TOP = "TOP",
  BOTTOM = "BOTTOM",
  CENTER = "CENTER",
}

export enum WindowVerticalDatum {
  TO_WALL_PLATE = "TO_WALL_PLATE",
  TO_FLOOR = "TO_FLOOR",
  WINDOW_HEAD_HEIGHT = "WINDOW_HEAD_HEIGHT",
}
